var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QS-common-table',{attrs:{"data":_vm.tableData,"columns":_vm.orderTableColumns,"row-key":"id","pagination":_vm.paginationData},on:{"change":_vm.paginationChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }